import React from 'react';

export const H1 = ({ children, className = '' }) => (
  <h1 className={`text-4xl md:text-6xl lg:text-7xl font-semibold tracking-tight text-navy-900 relative z-0 ${className}`}>
    {children}
  </h1>
);

export const H2 = ({ children, className = '' }) => (
  <h2 className={`text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-navy-900 relative z-0 ${className}`}>
    {children}
  </h2>
);

export const Text = ({ children, className = '', subtle = false }) => (
  <p className={`text-base md:text-lg leading-relaxed relative z-0 ${subtle ? 'text-slate-500' : 'text-slate-600'} ${className}`}>
    {children}
  </p>
);